import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header'
import FooterItem from "../../components/FooterItem";
import { getArticleById, getArticleListLength, ArticleList } from '../../api/mockData'
import { Flex, Menu, Table, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import './style.css'

const Archive = () => {
    const navigate = useNavigate();
    const [articleList, setArticleList] = useState([]);
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);

    // 初始化获取文章列表
    useEffect(() => {
        // 从API获取文章列表，注意索引从1开始
        const articles = [];
        for (let i = 1; i <= getArticleListLength(); i++) {
            const article = getArticleById(i);
            if (article) {
                articles.push(article);
            }
        }
        setArticleList(articles);

        // 提取所有年份并去重
        const allYears = [...new Set(articles.map(article => {
            return new Date(article.createTime).getFullYear();
        }))];
        setYears(allYears.sort((a, b) => b - a)); // 按年份倒序排列
        
        // 默认选中第一个年份
        if (allYears.length > 0) {
            setSelectedYear(allYears[0]);
        }
    }, []);

    // 根据选中的年份过滤文章
    const filteredArticles = selectedYear 
        ? articleList.filter(article => {
              return new Date(article.createTime).getFullYear() === selectedYear;
          })
        : articleList;

    // 处理年份选择
    const handleYearSelect = (year) => {
        setSelectedYear(year);
    };

    // 处理文章点击，跳转到PostDetail
    const handleArticleClick = (articleId) => {
        navigate(`/PostDetail/${articleId}`);
    };

    const columns = [
        {
            title: '文章',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (
                <a onClick={() => handleArticleClick(record.id)}>{text}</a>
            )
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
        }
    ];
    return (
        <div>
            <Header index={2}/>
            <Flex style={{ padding: '20px' }} gap="middle">
                <Menu 
                    className="archive-menu"
                    mode="inline"
                    selectedKeys={[selectedYear?.toString() || '']}
                >
                    <Menu.Item key="all" onClick={() => setSelectedYear(null)}>
                        全部文章
                    </Menu.Item>
                    {years.map(year => (
                        <Menu.Item 
                            key={year.toString()} 
                            onClick={() => handleYearSelect(year)}
                        >
                            {year}年
                        </Menu.Item>
                    ))}
                </Menu>
                <Table 
                    className="archive-table" 
                    columns={columns} 
                    dataSource={filteredArticles}
                    rowKey="id"
                    pagination={{ pageSize: 10 }}
                />
            </Flex>
            <FooterItem/>
        </div>
    ) 
}

export default Archive;